import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import { IconSettingsSliderHor } from 'central-icons/IconSettingsSliderHor';

import {
  usePageConfig,
  useTabContentConfig,
} from '../../PageConfigProvider/PageConfigProvider';
import { EnterParametersModal } from './EnterParametersModal';
import { ReportParametersModal } from './ReportParametersModal';
import { useUpdateParameters } from './useUpdateParameters';

export function EditParametersButton() {
  const { config: pageConfig } = usePageConfig();
  const { config: tabContent } = useTabContentConfig();
  const updateParameters = useUpdateParameters();

  const {
    isOpen: isParamsOpen,
    onOpen: onParamsOpen,
    onClose: onParamsClose,
  } = useDisclosure();
  const {
    isOpen: isSelectOpen,
    onOpen: onSelectOpen,
    onClose: onSelectClose,
  } = useDisclosure();

  return (
    <>
      <Menu>
        <MenuButton
          as={Button}
          size="sm"
          colorScheme="navyBlue"
          variant="ghost"
          leftIcon={<IconSettingsSliderHor size={16} />}
          aria-label="Parameter Options"
        >
          Parameters
        </MenuButton>
        <Portal>
          <MenuList>
            <MenuItem onClick={onSelectOpen}>Select Current</MenuItem>
            <MenuItem onClick={onParamsOpen}>Edit Parameters</MenuItem>
          </MenuList>
        </Portal>
      </Menu>
      <ReportParametersModal
        isOpen={isParamsOpen}
        onClose={onParamsClose}
        defaultValue={tabContent.reportParameters}
        onSave={(params) => {
          updateParameters(params ?? []);
        }}
      />
      <EnterParametersModal
        isOpen={isSelectOpen}
        onClose={onSelectClose}
        pageConfig={pageConfig}
        navigateOnSubmit={false}
      />
    </>
  );
}
